import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useRest } from "@/composables";

export const useActuacionesRecibidasStore = defineStore("actuacionesRecibidasStore", () => {
  const total = ref(0);
  const items = ref([]);
  const loading = ref(false);

  const page = ref(1);
  const rows = ref(10);
  const sortField = ref(null);
  const sortOrder = ref(-1); // 1 ASC, -1 DESC
  const offset = computed(() => (page.value - 1) * rows.value);

  const search = ref({});

  const rest = useRest();

  const getLimitValue = computed(() => rows.value);

  const getAll = async (searchParam = null) => {
    loading.value = true;
    try {
      const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/actuacion`;
      const searchParams = searchParam || search.value;
      const params = {
        search: searchParams,
        limit: rows.value,
        offset: offset.value || 0,
        order: sortField.value
          ? `${sortField.value} ${sortOrder.value === 1 ? "ASC" : "DESC"}`
          : null,
        getTotal: true,
        actuacionesRecibidas: true,
      };

      const { data } = await rest.get({ url, params });
      total.value = data.allrows;
      items.value = Array.isArray(data?.data) ? data.data : [];
    } catch (e) {
      console.error("[useActuacionesRecibidasStore.fetch]", e);
    } finally {
      loading.value = false;
    }
  };

  const setSort = async ({ field, order }) => {
    sortField.value = field ?? null;
    sortOrder.value = typeof order === "number" ? order : -1;
    page.value = 1;
    await getAll();
  };

  const setFilters = async (filtros = {}) => {
    search.value = filtros || {};
    page.value = 1;
    await getAll();
  };

  const goToPage = async ({ first, rows: r, page: p }) => {
    const rowsChanged = typeof r === "number" && r !== rows.value;
    if (rowsChanged) rows.value = r;

    if (typeof p === "number") {
      page.value = p + 1;
    } else if (typeof first === "number") {
      page.value = Math.floor(first / rows.value) + 1;
    }
    await getAll();
  };
  const setRows = async (r) => {
    rows.value = r;
    page.value = 1;
    await getAll();
  };

  const reset = async () => {
    items.value = [];
    total.value = 0;
    loading.value = false;
    page.value = 1;
    rows.value = 10;
    sortField.value = null;
    sortOrder.value = -1;
    search.value = {};
    await getAll();
  };

  const setTotal = (n) => {
    total.value = n;
  };

  return {
    // state
    items,
    total,
    loading,
    page,
    rows,
    sortField,
    sortOrder,
    offset,
    search,
    getLimitValue,

    // actions
    getAll,
    setSort,
    setFilters,
    goToPage,
    setRows,
    reset,

    // compat
    setTotal,
  };
});
